import Image from 'next/image';
import { FunctionComponent } from 'react';

interface Props {
  title: string;
  text: string;
  icon: string;
}

const Hero: FunctionComponent<Props> = ({ title, text, icon }) => {
  return (
    <main className="my-5 mx-auto max-w-7xl">
      <div className="flex content-center items-center justify-between">
        <div className="text-left w-full md:w-3/4 ">
          <h2 className="text-4xl md:text-5xl tracking-tight font-extrabold text-zinc-200">
            <span className="block xl:inline">{title}</span>
          </h2>
          <p className="mt-5 mb-5 font-light text-md md:text-xl text-zinc-200 w-full md:w-4/5">
            {text}
          </p>
        </div>
        <div className="relative invisible w-1 md:w-1/5 md:visible">
          <Image alt={title} src={icon} layout="intrinsic" height={200} width={200} />
        </div>
      </div>
    </main>
  );
};

export default Hero;
